import {
    HttpResponse,
    ResponseModel,
    QueryModel,
    RequestParams,
    ResponseModelIEnumerableApiResultSuccess,
    ResponseModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class IssuesDataService implements CrudService<ResponseModel, ResponseModel> {
    
    getAggregation(query: AggregationModel): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }

    getAll(query: CrudDataQuery<ResponseModel>): Promise<CrudEnumerableResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    getBasicAll(query: CrudDataQuery<ResponseModel>): Promise<CrudEnumerableResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    create(item: ResponseModel, params?: RequestParams): Promise<CrudResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    update(item: ResponseModel, params?: RequestParams): Promise<ResponseModel> {
        throw new Error('NotImplemented');
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ResponseModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<ResponseModel>): Promise<CrudEnumerableResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    download(query: CrudDataQuery<ResponseModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportIssueBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    clone(item: ResponseModel, params?: RequestParams): Promise<CrudResponse<ResponseModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
